(function () {
  const scrollKey = 'son-of-god-scroll:' + location.pathname;

  // Only restore on back/forward navigation (bfcache), not fresh loads
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return; // exit if it's a fresh page load

    const savedPosition = Number(sessionStorage.getItem(scrollKey));
    if (!Number.isFinite(savedPosition) || savedPosition <= 0) return;

    let attempts = 0;
    const maximumAttempts = 60;

    function attemptRestore() {
      const maximumScroll =
        document.documentElement.scrollHeight - window.innerHeight;

      if (maximumScroll >= savedPosition || attempts >= maximumAttempts) {
        window.scrollTo({ top: Math.min(savedPosition, maximumScroll), behavior: 'instant' });
        sessionStorage.removeItem(scrollKey); // clean up after restoring
        return;
      }

      attempts++;
      requestAnimationFrame(attemptRestore);
    }

    requestAnimationFrame(attemptRestore);
  });

  // Save position per page using pathname as the key
  window.addEventListener('pagehide', function () {
    if (window.scrollY > 0) {
      sessionStorage.setItem(scrollKey, window.scrollY);
    } else {
      sessionStorage.removeItem(scrollKey); // don't save if at top
    }
  });

})();
